var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSilence = function SvgSilence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 472.614 472.614"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.692 144.023C8.816 144.023 0 152.839 0 163.716v145.189c0 10.875 8.816 19.692 19.692 19.692h58.677V144.023zM271.898 60.148c0-15.304-17.368-24.139-29.737-15.128l-145.252 99v184.574l145.252 99c12.37 9.011 29.738.175 29.738-15.129zM472.614 172.465l-13.923-13.923-63.841 63.842-63.841-63.842-13.923 13.923 63.841 63.841-63.841 63.842 13.923 13.923 63.841-63.841 63.841 63.841 13.923-13.923-63.841-63.842z"
  })));
};
export default SvgSilence;